// monorepo/shared/auth/pages/OAuthSuccessPage.jsx
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { checkAuth } from '../Actions.jsx';

/**
 * OAuth Success Page
 *
 * This page handles the redirect after successful OAuth authentication.
 * It receives a token from the backend and completes the login process.
 */
const OAuthSuccessPage = ({ defaultRedirect = '/' }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const completeOAuthLogin = async () => {
      const token = searchParams.get('token');
      const provider = searchParams.get('provider');

      if (!token) {
        // No token - redirect to login with error
        navigate('/login?error=oauth_failed', { replace: true });
        return;
      }

      // Store the token from the OAuth callback
      // This is needed because cookies set by backend (port 5002) won't be
      // available to frontend (port 4204) in development
      localStorage.setItem('auth_token', token);

      // Now verify auth state - this will use the stored token
      try {
        const result = await dispatch(checkAuth());
        if (result === true) {
          // Auth successful - redirect to home or intended page
          navigate(defaultRedirect, { replace: true });
        } else {
          // Auth check failed - clear the token
          localStorage.removeItem('auth_token');
          navigate('/login?error=oauth_failed', { replace: true });
        }
      } catch (error) {
        console.error('OAuth completion error:', error);
        localStorage.removeItem('auth_token');
        navigate('/login?error=oauth_failed', { replace: true });
      }
    };

    completeOAuthLogin();
  }, [dispatch, navigate, searchParams, defaultRedirect]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-info mx-auto mb-4"></div>
        <p className="text-ink-muted">Completing sign in...</p>
      </div>
    </div>
  );
};

export default OAuthSuccessPage;
